import { render, staticRenderFns } from "./ResumenGeneral.vue?vue&type=template&id=15e8b2c0&scoped=true&lang=pug&"
import script from "./ResumenGeneral.vue?vue&type=script&lang=js&"
export * from "./ResumenGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ResumenGeneral.vue?vue&type=style&index=0&id=15e8b2c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8b2c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VList,VListGroup,VListTile,VListTileAvatar,VListTileContent,VListTileTitle})
